import React, { useState } from 'react';
import { ErrorMessage, Field, Form, Formik, yupToFormErrors } from 'formik';
import * as yup from 'yup'
import { rechercherpestataireservice, rechercherserviceparprestataire } from '../../services/prestataires/service';
import { enregistrerreversement } from '../../services/reversement/reversementRequest';
import $ from 'jquery';
import { rechercherprestatairestats } from '../../services/statistiques/StatistiquesRequest';
import Swal from 'sweetalert2';
import { Oval } from 'react-loader-spinner';
import { changeretatreversement } from '../../services/demande-reversement/DemandeRequest';
import { useTranslation } from 'react-i18next';


function AjoutReversement(props) {
    const { t } = useTranslation();
    const [listeService, setlisteService] = useState([]);
    const [montantApayer, setmontantApayer] = useState("");
    const [submitValues, setSubmitValues] = useState({});
    let [recupereServiceIdAndprestataireId, setRecupereServiceIdAndprestataireId] = useState({
        service_id: "",
        prestataires_id: ""
    });
    const [LabelServiceSelectionner, setLabelServiceSelectionner] = useState("");
    const [loading, setloading] = useState(false);
    const [messageError, setmessageError] = useState("")
    const [open, setOpen] = useState(false);


    const initialValues = {
        id: "",
        dateVersement: "",
        prestataires_id: "",
        service_id: "",
        resteAPayer: "",
        montant: "",
        commentaire: ""
    }

    const validationValuesSchema = yup.object().shape({
        dateVersement: yup.date().required(t('reversals.modal.errors.dateRequired')),
        montant: yup.number().required(t('reversals.modal.errors.amountRequired'))
    })

    let val = {};

    const handleOnsubmitReversement = (values) => {
        val = values
        val.prestataire_id = recupereServiceIdAndprestataireId.prestataires_id
        val.service_id = recupereServiceIdAndprestataireId.service_id
        document.getElementById("service_id").value !== "" && setLabelServiceSelectionner(document.getElementById("service_id").options[document.getElementById("service_id").selectedIndex].text);

        const swalWithBootstrapButtons = Swal.mixin({
            customClass: {
                confirmButton: 'btn btn-success mx-2',
                cancelButton: 'btn btn-danger'
            },
            buttonsStyling: false
        })

        swalWithBootstrapButtons.fire({
            title: t('reversals.modal.confirmTitle'),
            text: "Service : " + LabelServiceSelectionner + " , Montant : " + values.montant + " FCFA",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: t('reversals.modal.confirmYes'),
            cancelButtonText: t('reversals.modal.confirmNo'),
            reverseButtons: true
        }).then((result) => {
            if (result.isConfirmed) {
                setloading(true)
                enregistrerreversement(val).then((res) => {
                    changeretatreversement(val.service_id).then(() => {
                        setloading(false)
                        props.afficherreversements(1);
                        swalWithBootstrapButtons.fire(
                            t('reversals.modal.successTitle'),
                            t('reversals.modal.successMessage'),
                            'success'
                        )
                        setlisteService([]);
                        setmontantApayer("");
                        setmessageError("");
                        props.setPageActive(1);
                        document.getElementById("resteAPayer").value = "";
                        setOpen(false);
                        $('#fermer').trigger('click');
                    }).catch(()=>{
                        setloading(false)
                    })


                }).catch((error) => {
                    setloading(false);
                    console.log(error.response.data);
                    if (typeof error.response.data.donnee === 'object') {
                        error.response.data.donnee.service_id !== undefined && setmessageError(t('reversals.modal.errors.serviceRequired'))
                        error.response.data.donnee.prestataire_id !== undefined && setmessageError(t('reversals.modal.errors.providerRequired'))

                    } else if (typeof error.response.data.donnee === 'string') {
                        setmessageError(error.response.data.donnee)
                    }

                })


            } else if (
                /* Read more about handling dismissals below */
                result.dismiss === Swal.DismissReason.cancel
            ) {
                swalWithBootstrapButtons.fire(
                    t('reversals.modal.cancelTitle'),
                    t('reversals.modal.cancelMessage'),
                    'error'
                )
            }
        })




    }


    const handleService = (e) => {
        recupereServiceIdAndprestataireId.prestataires_id = e.target.value;
        recupereServiceIdAndprestataireId.service_id = "";
        setRecupereServiceIdAndprestataireId(recupereServiceIdAndprestataireId);

        if (recupereServiceIdAndprestataireId.prestataires_id !== "") {
            rechercherserviceparprestataire(recupereServiceIdAndprestataireId.prestataires_id).then((res) => {
                setlisteService(res.data.donnee);
                afficherResteApayer()
            })
        } else {
            setlisteService([]);
            setmontantApayer("");
        }
    }
    const recuperationResteApayer = (e) => {

        recupereServiceIdAndprestataireId.service_id = e.target.value;
        setLabelServiceSelectionner(document.getElementById("service_id").options[document.getElementById("service_id").selectedIndex].text)
        setRecupereServiceIdAndprestataireId(recupereServiceIdAndprestataireId);
        if (recupereServiceIdAndprestataireId.prestataires_id === "" && recupereServiceIdAndprestataireId.service_id === "") { setmontantApayer("") }
        else {
            afficherResteApayer()
        }

    };

    const afficherResteApayer = () => {
        rechercherprestatairestats(recupereServiceIdAndprestataireId).then((res) => {
            setmontantApayer(res.data.donnee);
        })
    }

    const optionListPrestataire = props.listePrestataire.map((item) => (
        <option key={item.id} value={item.id}>{item.nom}</option>
    ));

    const optionListservice = listeService.map((item) => (
        <option key={item.id} value={item.id}>{item.designation}</option>
    ));


    return <div className="modal fade" id="ajoutReversement" data-bs-backdrop="static" data-bs-keyboard="false" tabIndex={-1} aria-labelledby="staticBackdropLabel" aria-hidden="true">
        <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content blueSkanpay">
                <div className="modal-header text-white">
                    <h5 className="modal-title" id="staticBackdropLabel">{t('reversals.modal.title')}</h5>
                    <button type="button" className="bg-danger btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                </div>
                <div className="modal-body bg-white">

                    <Formik
                        initialValues={initialValues}
                        enableReinitialize
                        validationSchema={validationValuesSchema}
                        onSubmit={handleOnsubmitReversement}
                    >
                        {({ resetForm }) => (
                            <Form>
                                {messageError !== "" && <p className='text-danger'><i className='fa fa-exclamation-triangle'></i> {messageError}</p>}

                                <div className="mb-3">
                                    <label className="form-label " htmlFor="dateVersement">{t('reversals.modal.reversalDate')}</label>
                                    <Field className="form-control" type="date" id="dateVersement" name="dateVersement" />
                                    <p className='text-danger'><ErrorMessage name="dateVersement"></ErrorMessage></p>
                                </div>
                                <div className='mb-3' >
                                    <label htmlFor="prestataires_id" className='form-label'>{t('reversals.modal.provider')}</label>
                                    <Field component="select" onChange={handleService} value={recupereServiceIdAndprestataireId.prestataires_id} className='form-control form-select' id='prestataires_id' name="prestataires_id" >
                                        <option value="">{t('reversals.modal.selectProviderPlaceholder')}</option>
                                        {optionListPrestataire}
                                    </Field>
                                    <p className='text-danger'><ErrorMessage name="prestataires_id"></ErrorMessage></p>
                                </div>
                                <div className='mb-3' >
                                    <label htmlFor="service_id" className='form-label'>{t('reversals.modal.service')}</label>
                                    <Field component="select" onChange={recuperationResteApayer} value={recupereServiceIdAndprestataireId.service_id} className='form-control form-select' id='service_id' name="service_id" >
                                        <option value="">{t('reversals.modal.selectServicePlaceholder')}</option>
                                        {optionListservice}
                                    </Field>
                                    <p className='text-danger'><ErrorMessage name="service_id"></ErrorMessage></p>
                                </div>


                                <div className="mb-3">
                                    <label htmlFor="resteAPayer" className="form-label">{t('reversals.modal.remainingToReverse')}</label>
                                    <Field className="form-control text-danger fs-5 fw-bold" name="resteAPayer" id="resteAPayer" value={montantApayer} disabled />
                                    {/* <p id="resteAPayer" className='fw-bold text-danger'>{montantApayer}</p> */}
                                </div>

                                <div className="mb-3">
                                    <label htmlFor="montant" className="form-label">{t('reversals.modal.amountToReverse')}</label>
                                    <Field type="number" className="form-control" id="montant" name="montant" />
                                    <p className='text-danger'><ErrorMessage name="montant"></ErrorMessage></p>
                                </div>
                                <div className="mb-3">
                                    <label htmlFor="commentaire" className='form-label'>{t('reversals.modal.comment')}</label>
                                    <Field as="textarea" name="commentaire" id="commentaire" className="form-control"></Field>
                                </div>

                                <div className="modal-footer bg-white">
                                    <button id='fermer' type="button" onClick={() => {
                                        resetForm(); setmessageError(""); setlisteService([]); setmontantApayer(""); setRecupereServiceIdAndprestataireId({
                                            service_id: "",
                                            prestataires_id: ""
                                        })
                                    }}
                                        className="btn btn-sm btn-secondary" data-bs-dismiss="modal">{t('reversals.modal.close')}</button>
                                    <Oval width={30} height={30} color="#344b7b" visible={loading} />
                                    {!loading && <button type="submit" className="btn btn-sm btn-primary">{t('reversals.modal.save')}</button>}

                                </div>
                            </Form>
                        )}
                    </Formik>

                </div>
            </div>
        </div>
    </div>
}


export default AjoutReversement;
